// extracted by mini-css-extract-plugin
export default {"container":"doughnut_container__1lYmb","icon":"doughnut_icon__DpEgp","iconSize":"doughnut_iconSize__eJMcV","textHelper":"doughnut_textHelper__y2FIh"};